export default "__VITE_ASSET__0bb7f41a__"